/**
 * Immutable deep-set helper used across all MainSettings panels.
 * `setPath(obj, ["a", "b", 0, "c"], v)` returns a new object with the
 * nested value replaced, copying every intermediate container.
 */
export const setPath = (obj, path, value) => {
  const out = Array.isArray(obj) ? [...obj] : { ...obj };
  let cur = out;
  for (let i = 0; i < path.length - 1; i++) {
    const k = path[i];
    const next = cur[k];
    const copy = Array.isArray(next) ? [...next] : { ...next };
    cur[k] = copy;
    cur = copy;
  }
  cur[path[path.length - 1]] = value;
  return out;
};
